import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export function isSnakeCase(str) {
  const snakeCaseRegex = /^[a-z]+(_[a-z]+)*$/;
  return snakeCaseRegex.test(str);
}

export function snakeToTitleCase(input) {
  return input
    .toLowerCase() // Convert the entire string to lowercase
    .split('_') // Split the string into an array at underscores
    .map((word, index) =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ) // Capitalize the beginning of every word
    .join(' '); // Join the words with spaces
}

export function JsonTable({ jsonData, idx }) {
  // Parse the JSON string to a JavaScript object
  const obj = JSON.parse(jsonData);

  const data = Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null && v !== '' && v !== false));

  // Extract headers (keys of the object)
  const headers = Object.keys(data);

  console.log(data);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {headers.map((header, index) => (
            <TableRow key={`${idx}-${header}-${index}`}>
              <TableCell
                sx={{
                  whiteSpace: 'normal', // Allow text to wrap
                  wordWrap: 'break-word', // Break long words
                  maxWidth: 300, // Optional: Set a max width for cells
                }}
              >
                <strong>{snakeToTitleCase(header)}</strong>
              </TableCell>
              <TableCell
                sx={{
                  whiteSpace: 'normal', // Allow text to wrap
                  wordWrap: 'break-word', // Break long words
                  maxWidth: 400, // Optional: Set a max width for cells
                }}
              >
                {typeof data[header] === 'string' ? data[header] : JSON.stringify(data[header])}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
